/**
 * Configuración del selector de preguntas para fichas de Miel.
 * Independiente de config.js (Café): en Miel los datos salen del JSON de Mongo,
 * así que no se exige config_rpt_tabla/config_rpt_columna.
 */

export const MIEL_FORM_CONFIG = {
  // Tipos que no generan dato en el JSON (o son metadatos del dispositivo)
  excludeByType: ['note', 'start', 'end', 'today', 'deviceid', 'subscriberid', 'simserial', 'phonenumber', 'username', 'start-geopoint'],

  // Nombres de pregunta a ocultar (coincidencia exacta)
  excludeByName: [],

  // Grupos a ocultar por name (coincidencia exacta, incluye sus hijos)
  excludeGroupsByName: [],

  // Mostrar el name (clave del JSON) junto a la etiqueta
  showName: true,
};

export const MIEL_GROUP_PRESELECTION = {
  enabled: false,
  groups: [],
};
